var map = {
	"./fino.png": 7637,
	"./fino2.png": 5120,
	"./fino3.png": 525,
	"./normal.png": 5134,
	"./normal2.png": 1838,
	"./normal3.png": 3175,
	"./zoião.png": 7247,
	"./zoião2.png": 5181,
	"./zoião3.png": 5236,
	"./zoião4.png": 6891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9713;